exports = module.exports = require("./../../../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".message-preview-wrapper{margin-left:15px;margin-right:15px}.message-preview-wrapper dl{margin-top:5px;margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/~/css-loader!./src/web/simulator/SimulationResults.css
// module id = 462
// module chunks = 0